// src/components/CustomPaginate/CustomPaginate.js

import React from "react";
import "./CustomPaginate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const CustomPaginate = ({
  currentPage = 1,
  totalPages = 1,
  handlePageChange: onPageChange,
}) => {
  const pageRange = 2;

  const handlePageChange = (page) => {
    onPageChange(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPages = () => {
    const pages = [];

    let start = currentPage - pageRange;
    let end = currentPage + pageRange;

    // Near Start
    if (currentPage <= pageRange + 1) {
      start = 1;
      end = Math.min(totalPages, pageRange * 2 + 1);
    }

    // Near End
    if (currentPage >= totalPages - pageRange) {
      end = totalPages;
      start = Math.max(1, totalPages - pageRange * 2);
    }

    // First Page
    if (start > 1) {
      pages.push(
        <button key={1} onClick={() => handlePageChange(1)}>
          1
        </button>,
      );

      if (start > 2) {
        pages.push(<span key="start-ellipsis">...</span>);
      }
    }

    // Dynamic Pages
    for (let page = start; page <= end; page++) {
      pages.push(
        <button
          key={page}
          className={currentPage === page ? "active" : ""}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </button>,
      );
    }

    // Last Page
    if (end < totalPages) {
      if (end < totalPages - 1) {
        pages.push(<span key="end-ellipsis">...</span>);
      }

      pages.push(
        <button key={totalPages} onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </button>,
      );
    }

    return pages;
  };

  return (
    <div className="pagination-wrapper">
      {/* Previous */}
      <button
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
      </button>

      {renderPages()}

      {/* Next */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        <FontAwesomeIcon icon={faArrowRight} />
      </button>
    </div>
  );
};

export default CustomPaginate;
